import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export type LegalAndNewsletterCheckboxForm = {
    privacyPolicy: boolean;
    generalTerms: boolean;
    newsLetter: boolean;
    valid: boolean;
    allRequiredAccepted: boolean;
};

@Component({
    selector: 'app-legal-and-newsletter-checkbox',
    templateUrl: './legal-and-newsletter-checkbox.component.html',
    styleUrls: ['./legal-and-newsletter-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@UntilDestroy()
export class LegalAndNewsletterCheckboxComponent implements OnInit {
    public readonly privacyPolicyLink = `https://app.keystone.live/assets/docs/keystone-privacy-policy-hu.html?v=${new Date().getTime()}`;
    public readonly termsOfServiceLink = `https://app.keystone.live/assets/docs/keystone-terms-of-service-hu.html?v=${new Date().getTime()}`;

    public form = this.fb.group({
        privacyPolicy: this.fb.control(false, [Validators.requiredTrue]),
        generalTerms: this.fb.control(false, [Validators.requiredTrue]),
        newsLetter: this.fb.control(false)
    });

    @Output() formChanges = new EventEmitter<Partial<LegalAndNewsletterCheckboxForm>>();

    constructor(private readonly fb: NonNullableFormBuilder) {}

    ngOnInit(): void {
        this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            this.formChanges.emit({
                ...value,
                allRequiredAccepted: value.generalTerms && value.privacyPolicy,
                valid: this.form.valid
            });
        });
    }
}
